module.exports = __webpack_public_path__ + "img/ggz_area.802f298f.png";